export default "__VITE_ASSET__BqQJF_qX__"